import React, { useEffect, useState, useContext } from 'react';
import Popover from '../../../UI/Popover/Popover'
import css from './ContainerDeleteModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
  
const ContainerDeleteModal = ({ containerService, defaultContainer }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);


    const [isVisibleRedistribute, setIsVisibleRedistribute] = useState(false);  


    const confirmDelete = () => { 
        containerService.remove(defaultContainer.id)
            .then((response) => {
                setIsModalOpen(false)
                containerService.fetchList()

            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return (
        <>                           
             

            <Popover key={defaultContainer.id} placement='bottom' isVisiblePopover={isVisibleRedistribute} content={<> 
                    <div style={{ minWidth: '200px' }} >
                        <div className={ css.message } >გსურთ კონტეინერის წაშლა?</div>
                        <div className={ css.buttons }>
                            <button className={ css.removeBtnYes } onClick={confirmDelete}>დიახ მსურს!</button> 
                        </div> 
                    </div> 
                </>}> 
 
                <span className={css.btnContainerTop} onClick={() => openDelete()} >
                    <span className={css.icon  }><Remove/> </span>
                    წაშლა
                </span>
                
            </Popover> 

        </>
    );
};

export default ContainerDeleteModal;